import React from 'react';
import { Form, Select, Typography, Switch } from 'antd';

const { Text } = Typography;
const { Option } = Select;

const DistinctNodeProperties = ({ config, inputSchema }) => {
  return (
    <>
      <Form.Item label="Distinct Columns" name="columns" initialValue={config.columns || []} rules={[{ required: true }]}>
        <Select 
          mode="tags" 
          placeholder="Select columns to check for uniqueness (leave empty for all columns)"
          allowClear
        >
          {inputSchema && inputSchema.map(col => (
            <Option key={col.name} value={col.name}>{col.name}</Option>
          ))}
        </Select>
      </Form.Item>
      
      <Form.Item label="Keep First Occurrence" name="keepFirst" initialValue={config.keepFirst !== false} valuePropName="checked">
        <Switch />
      </Form.Item>

      <Form.Item label="Case Sensitive" name="caseSensitive" initialValue={config.caseSensitive !== false} valuePropName="checked">
        <Switch />
      </Form.Item>

      <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px', marginTop: '12px' }}>
        <Text type="secondary">
          <strong>Distinct/Unique Node:</strong><br/>
          • Removes duplicate rows based on specified columns<br/>
          • If no columns specified, checks entire row<br/>
          • Keep First: Retains first occurrence of duplicates<br/>
          • Case Sensitive: Whether text comparison is case-sensitive
        </Text>
      </div>
    </>
  );
};

export default DistinctNodeProperties;